import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#242E30] text-white py-12" data-testid="footer">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <span className="font-extrabold text-2xl text-white">
              Zoopbowl
            </span>
            <p className="text-white/60 text-sm mt-3">
              Discover daily deals from local restaurants.
            </p>
          </div>

          {/* Discover */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/80">
              Discover
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/deals" className="text-white/60 hover:text-white text-sm transition-colors">
                  Browse Deals
                </Link>
              </li>
              <li>
                <Link to="/restaurants" className="text-white/60 hover:text-white text-sm transition-colors">
                  Restaurants
                </Link>
              </li>
            </ul>
          </div>

          {/* Partner */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/80">
              Partner with us
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/register?role=restaurant" className="text-white/60 hover:text-white text-sm transition-colors">
                  List your restaurant
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/80">
              Help
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/login" className="text-white/60 hover:text-white text-sm transition-colors">
                  Log in
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-white/60 hover:text-white text-sm transition-colors">
                  Sign up
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-8 text-center text-white/40 text-xs">
          <p>&copy; {new Date().getFullYear()} Zoopbowl. All rights reserved.</p>
          <p className="mt-2">Restaurant data contains FSA data (Open Government Licence) and &copy; OpenStreetMap contributors.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
